<div
  class="text-center relative bg-better-deal color-light border-radius-5 overflow-hidden m-a card-container"
  style="max-width: fit-content">
  <!-- Header -->
  <cp-widget-header text="Better deal found" icon="map-location" [isAbsolutePosition]="true" />

  <!-- Video -->
  @if (!isExpired) {
    <div
      class="absolute z-index-3 bottom-3"
      visibility
      (visibilityChange)="playVideo($event)"></div>
    <div class="relative">
      <video
        class="border-radius-5"
        #bestDealVid
        (ended)="videoEnded = true"
        style="width: 100%; height: 100%"
        playsinline
        [poster]="'dashboard-widget-poster-better-deal-expiring.jpg' | brandingAssetPath"
        [muted]="muted">
        @if (!widget.isCompanyBranded) {
          <source src="/assets/videos/better-deal-expiring.mp4" type="video/mp4" />
        }
        Your browser does not support the video tag.
      </video>
    </div>
  }

  <!-- Contents -->
  @if (isExpired) {
    <ng-container *ngTemplateOutlet="expired" />
  } @else {
    <ng-container *ngTemplateOutlet="notExpired" />
  }

  <ng-container *ngTemplateOutlet="betterDeals" />
</div>

<ng-template #expired>
  <div class="px-5 text-center pt-5 pb-3">
    <div class="bold-800 text-28 mt-3">You’re probably overspending on your mortgage</div>
    <div class="text-14 mt-5">
      @if (isExperianCompany$ | async) {
        Remember - your lender updates us every 4 to 6 weeks. This means that some information can
        look out of date until we next hear from them.
      } @else {
        If you've already switched elsewhere, please update your app with the new deal so we can
        monitor it for you.
      }
    </div>
    <div class="pt-5">
      <img style="height: 11rem" [src]="'stacked-coins-2.png' | brandingAssetPath" alt="" />
    </div>
  </div>
</ng-template>

<ng-template #notExpired>
  <div class="w-100 h-100 z-index-1 absolute video-content pt-5 pb-3">
    <div class="text-28 bold-800 px-3 text-center pt-2 pb-5">
      Good news! We've uncovered a better deal just for you.
    </div>

    <div class="text-14 px-5 bottom-3 pb-5 text-center">
      We just found <b>86 new better deals</b> for your <b>My Home HSBC</b> mortgage.
    </div>
  </div>
</ng-template>

<ng-template #betterDeals>
  <div
    class="w-100 h-100 absolute z-index-2 bg-better-deal clickable-content pt-5 gap-3 overflow-hidden view-content animation-delay-expired"
    [ngClass]="{ 'animation-delay': playVideoTriggered, 'animation-delay-expired': isExpired }">
    <div class="pt-5 px-5 text-28 bold-800 text-center px-3">Here are the best of them</div>
    <div style="align-self: center">
      <cp-better-deal-ticket-carousel [mortgageId]="widget.mortgage.id" />
    </div>

    <div class="pb-5 w-fit m-a layout-fr-auto gap-2 px-3">
      @if (isExpired) {
        <button
          *hasCompanyClientUiSettingsEnabled="showMortgageEditingKey"
          pButton
          class="p-button centered p-button-better-deal w-100 p-button-outlined color-light"
          (click)="seeMortgage()">
          Update mortgage
        </button>
      }

      <button pButton class="p-button centered p-button-better-deal" (click)="seeAll()">
        <ng-container *hasCompanyClientUISettingsDisabled="showOnlyBestDealInComparisonResults">
          See all better deals
        </ng-container>
        <ng-container *hasCompanyClientUiSettingsEnabled="showOnlyBestDealInComparisonResults">
          More details
        </ng-container>
      </button>
    </div>
  </div>
</ng-template>
